import { createSlice } from "@reduxjs/toolkit";

interface IntialStateInterface {
  menus: any[];
  loading: boolean;
  error: any;
  rowsPerPage: number;
}

const initialState: IntialStateInterface = {
  menus: [],
  loading: false,
  error: null,
  rowsPerPage: 10,
};

const menusSlice = createSlice({
  name: "menus",
  initialState,
  reducers: {
    getMenuItemsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getMenuItemsSuccess(state, action) {
      state.menus = action.payload;
      state.loading = false;
      state.error = null;
    },
    getMenuItemsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },
    clearRowsPerPage(state) {
      state.rowsPerPage = 10;
    }
  },
});

export const { getMenuItemsStart, getMenuItemsSuccess, getMenuItemsFailure, setRowsPerPage, clearRowsPerPage } =
  menusSlice.actions;

export default menusSlice.reducer;
